import { Box, type BoxProps, Link } from "@chakra-ui/react";
import { Text } from "@equidefi/ui";

const REG_A_LIMIT_INFO_URL =
  "https://www.sec.gov/resources-small-businesses/regulation-guidance-issuers#:~:text=Regulation%20A%20limits,non%2Dnatural%20persons)";

const DEFAULT_DESCRIPTION =
  "Based on your stated income and net worth, you are not able to make further investments in this offering using your existing information. Tap this card to learn more.";

type InvestmentLimitCardProps = {
  /** Body copy; defaults to the standard Reg A 10% limit message. */
  description?: string;
} & BoxProps;

/**
 * Reg A 10% limit warning shown when a non-accredited investor has reached the
 * maximum they can invest based on their income/net worth. Links to the SEC's
 * Regulation A guidance.
 */
export const InvestmentLimitCard = ({ description = DEFAULT_DESCRIPTION, ...boxProps }: InvestmentLimitCardProps) => {
  return (
    <Link href={REG_A_LIMIT_INFO_URL} rel="noopener noreferrer" target="_blank" _hover={{ textDecor: "none" }}>
      <Box borderRadius="12px" p="4" bgColor="#fef4e7" borderColor="equidefi.yellow" borderWidth="2px" {...boxProps}>
        <Text my="0" mb="0" fontSize="xs" textTransform="uppercase">
          Invest Again
        </Text>
        <Text as="h3" mb="0" fontWeight="bold" fontSize="lg">
          Investment Limit Reached
        </Text>
        <Text mb="0" textStyle="body">
          {description}
        </Text>
      </Box>
    </Link>
  );
};
